export default "__VITE_ASSET__iqETy4fn__"